import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'


// 固化语言包
const randomEventLangUpload = obj => new Promise((resolve, reject) => {
    const {
        randomEventLangBO,
        token
    } = obj;
    request({
        url: apis.random_event_lang_upload + '?token=' + token,
        data: randomEventLangBO
    }).then(res => {
        resolve(res);
    })
});

// 剧本语言包
const randomEventLangs = token => new Promise((resolve, reject) => {
    request({
        url: apis.random_event_langs + '?token=' + token
    }).then(res => {
        resolve(res);
    })
});

export default {
    randomEventLangUpload,
    randomEventLangs
}



// WEBPACK FOOTER //
// ./src/service/dialog_api.js